<template>
  <div class="big">
    <div class="b"></div>
    <div class="bigCenter">
      <div class="news">
        <div class="NEWS">NEWS</div>
        <div class="newsInformation">
          <span>{{ BigNew.column }}</span>
          <ul style="display:none">
            <li
              :class="{ active: index === curId }"
              v-for="(item, index) in NewsNav"
              :key="item.id"
              @click="INDEX(index)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div
          class="imgCompilations wow animated bounceInUp"
          data-wow-duration="2s"
          data-wow-delay=".5"
          data-wow-offset="0"
          v-for="(item, index) in NewsNav"
          :key="item.id"
          v-show="index === curId"
        >
          <div class="img1" v-for="item in HomeList.data" :key="item.id">
            <router-link
              :to="{ name: 'Details', params: { id: item.id, modular: 2 } }"
              tag="a"
              ><img class="" :src="item.images" alt=""
            /></router-link>
            <p class="p1">
              <router-link
                :to="{ name: 'Details', params: { id: item.id, modular: 2 } }"
                tag="a"
                :title="item.title"
                >{{ item.title }}</router-link
              >
            </p>
            <p class="p2">
              <router-link
                :to="{ name: 'Details', params: { id: item.id, modular: 2 } }"
                tag="a"
              >
                {{ item.brief }}</router-link
              >
            </p>
            <p class="p3">{{ item.addtime | formatDate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { getNews, getHeards, GetColumn_List } from "@/https/http";
import { formatDate } from "@/js/data.js";
export default {
  data() {
    return {
      n: 4,
      HomeList: "",
      NewList: "",
      NewsNav: "",
      curId: 0,
      BigNew: "",
    };
  },
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    },
  },

  created() {
    getHeards({ type: 2 }).then((res) => {
      this.NewList = res.result.data;
      this.NewList.forEach((item) => {
        if (item.modular === "2") {
          this.NewsNav = item.str;
        }
      });
      GetColumn_List({
        number: 4,
        modular: 2,
        column_id: this.NewList[this.curId].id,
      }).then((res) => {
        if (res.result.data.length === 0) {
          getNews({ number: 4 }).then((res) => {
            this.BigNew = res.result;
            console.log(this.BigNew);

            this.HomeList = res.result;
          });
        } else {
          this.HomeList = res.result;
        }
      });
    });
  },
  mounted() {
    var btns = document.querySelectorAll(".newsInformation ul > li");
    for (let i = 0; i < btns.length; i++) {
      btns[i].dataset.index = i;
      (btns[i].onclick = function () {
        var index = this.dataset.index - 0;
        for (var i = 0; i < btns.length; i++) {
          btns[i].classList.remove("active");
        }
        btns[index].classList.add("active");
      }),
        (this.$parent.color = `#000`);
      this.$parent.backgroundColor = "#fff";
      let wow = new WOW({
        boxClass: "wow", //需要执行动画的元素的 class
        animateClass: "animated", //animation.css 动画的 class
        offset: 0, //距离可视区域多少开始执行动画
        mobile: true, //是否在移动设备上执行动画
        live: true, //异步加载的内容是否有效
      });
      wow.init();
    }
  },
  methods: {
    Btn() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    INDEX(x) {
      this.curId = x;
      GetColumn_List({
        number: 4,
        modular: 2,
        column_id: this.NewList[this.curId].id,
      }).then((res) => {
        if (res.result.data.length === 0) {
          getNews({ number: 4 }).then((res) => {
            this.HomeList = res.result;
          });
        } else {
          this.HomeList = res.result;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
@media screen and (min-width: 1020px){
  .big {
  width: 100%;
  min-width: 1427px;
  height: 937px;
  background-color: rgba(229, 226, 221, 0.16);
  .bigCenter {
    width: 1427px;
    height: 937px;
    margin: 0 auto;
    .news {
      width: 100%;
      min-width: 1427px;
      height: 105px;
      padding-top: 140px;

      .NEWS {
        width: 94px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #b3b3b3;
        line-height: 30px;
      }
      .newsInformation {
        margin-top: 26px;
        > span {
          width: 235px;
          height: 60px;
          font-size: 60px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #4d4d4d;
          line-height: 30px;
        }
      }
      ul {
        list-style: none;
        display: flex;
        float: right;
        li.active {
          color: #ff8229;
        }
        li {
          width: 64px;
          height: 16px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 30px;
          margin-left: 63px;
        }
        li:hover {
          color: #ff8229;
          cursor: pointer;
        }
      }
      .imgCompilations {
        width: 100%;
        display: flex;
        margin-top: 95px;
        justify-content: space-between;
        .p3 {
          width: 95px;
          height: 14px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 23px;
          margin-left: 21px;
          margin-top: 18px;
          /* margin-bottom: 25px; */
        }

        .img1 {
          width: 350px;
          height: 483px;
          background: #ffffff;
          position: relative;
          display: block;
          img {
            width: 100%;
            height: 292px;
            position: absolute;
            top: 0;
            left: 0;
            transition: all 0.36s ease 0s;
            display: block;
            position: relative;
          }
          .p1 {
            width: 302px;
            /* height: 19px; */
            margin-left: 21px;
            margin-top: 26px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .p1 > a {
            width: 302px;
            height: 19px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
            cursor: pointer;
            text-decoration: none;
          }
          .p2 {
            width: 306px;
            height: 66px;
            margin-left: 21px;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .p2 > a {
            width: 306px;
            height: 47px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 30px;
            cursor: pointer;
            text-decoration: none;
          }
        }
        .img1:hover {
          border-bottom: 4px solid #ff8229;
          .p1 > a {
            color: #ff8229;
          }
        }
      }
    }
  }
}
}

@media screen and (max-width:1020px){
  .big{
    width: 100%;
    height: 950px;
    background-color: rgba(229, 226, 221, 0.16);
    .bigCenter{
      width: 100%;
      .news{
        width: 100%;
        height: 950px;
        padding-left:20px;
        padding-right:20px;
        box-sizing: border-box;
        padding-top:30px;

        .NEWS{
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #b3b3b3;
          line-height: 30px;
        }
        .newsInformation {
          margin-top: 16px;
          > span {
            height: 60px;
            font-size: 40px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #4d4d4d;
            line-height: 30px;
          }
        }
        .imgCompilations {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 45px;
          justify-content: space-between;
          .p3 {
            // width: 95px;
            height: 14px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 23px;
            margin-left: 21px;
            margin-top: 18px;
          }

        .img1 {
          width: 49%;
          height: 370px;
          background: #ffffff;
          position: relative;
          display: block;
          margin-bottom:10px;
          img {
            width: 100%;
            // height: 292px;
            position: absolute;
            top: 0;
            left: 0;
            transition: all 0.36s ease 0s;
            display: block;
            position: relative;
          }
          .p1 {
            // width: 302px;
            /* height: 19px; */
            margin-left: 21px;
            margin-top: 26px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .p1 > a {
            // width: 302px;
            height: 19px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
            cursor: pointer;
            text-decoration: none;
          }
          .p2 {
            // width: 306px;
            height: 66px;
            margin-left: 21px;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .p2 > a {
            // width: 306px;
            height: 47px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 30px;
            cursor: pointer;
            text-decoration: none;
          }
        }
        }

      }
    }
  }
}

</style>